export default __webpack_public_path__ + "static/media/aws-ec-2-image-circle-solid.c48ffc3b.svg";